import styled from 'styled-components';

export const StyledWrapper = styled.div`
  .coupon-list-search-box {
    .amondz-form {
      .quick-date-picker {
        display: flex;

        .button-list {
          margin-right: 20px;
        }
      }
    }
  }
`;
